export enum STATUS_BACKGROUND {
  GREEN = 'border-green-100 text-green-600 bg-white bg-gradient-to-t from-green-600/10 to-green-600/10',
  YELLOW = 'border-yellow-100 text-yellow-700 bg-white bg-gradient-to-t from-yellow-50 to-yellow-50',
  RED = 'border-red-100 text-red-600 bg-white bg-gradient-to-t from-red-50 to-red-50',
  PRIMARY = 'border-primary-100 text-primary-600 bg-white bg-gradient-to-t from-primary-600/10 to-primary-600/10',
  RED_LIGHT = 'border-red-100 text-red-400 bg-white bg-gradient-to-t from-red-400/10 to-red-400/10',
  GENERIC = 'border-primary-100 text-primary-500 bg-white bg-gradient-to-t from-primary-500/10 to-primary-500/10',
  GRAY = 'border-gray-100 text-gray-600 bg-white bg-gradient-to-t from-gray-50 to-gray-50',
}
